import type { VenderMiniEntity } from './VenderMiniEntity'

export class VenderResponseEntity {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<VenderMiniEntity> | null
}
